class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersFormMobileRight .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersFormMobileRight .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);
    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const selections = document.querySelectorAll(selector)
      selections.forEach((element) => {
        element.innerHTML = activeFacetsElement.innerHTML;
      })
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting',
      '.mobile-facets__selected-summary',
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const target = document.querySelector(selector);
      if (!target) return;
      target.innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    document.getElementById('FacetFiltersFormMobileRight').closest('menu-drawer').bindEvents();
    FacetFiltersForm.dispatchActiveFacetsCount(html);
  }

  static dispatchActiveFacetsCount(html) {
    if (!html) return;
    const source = html.querySelector('[data-active-facets-count]');
    const rawValue = source ? source.getAttribute('data-active-facets-count') : null;
    const parsedValue = rawValue !== null ? parseInt(rawValue, 10) : 0;
    const count = Number.isNaN(parsedValue) ? 0 : parsedValue;
    document.dispatchEvent(
      new CustomEvent('facets:count-changed', {
        detail: { count },
      })
    );
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className.includes('mobile-facets__checkbox')) {
      const formIds = ["FacetFiltersFormMobile", "FacetFiltersFormMobileRight"];
      const forms = [];
      formIds.forEach((formId) => {
        forms.push(this.createSearchParams(document.getElementById(formId)));
      });
      this.onSubmitForm(forms.join('&'), event);
      // const searchParams = this.createSearchParams(event.target.closest('form'));
      // this.onSubmitForm(searchParams, event);
      if (event.srcElement.className.includes('filters-right')) {
        const closeBtn = document.querySelector('.mobile-close-right');
        if (closeBtn) {
          closeBtn.click(); // programmatically triggers the click
        }
      } else {
        const closeBtn = document.querySelector('.mobile-close-left');
        if (closeBtn) {
          closeBtn.click(); // programmatically triggers the click
        }

      }
    } else {
      const forms = [];
      const currentForm = event.target.closest('form');
      const formId = currentForm ? currentForm.id : '';
      const isMobile = formId === 'FacetFiltersFormMobile' || formId === 'FacetFiltersFormMobileRight';
      const isRightDrawerSort =
        formId === 'FacetFiltersFormMobileRight' &&
        event.target.name === 'sort_by';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetFiltersFormMobileRight') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);

      if (isMobile) {
        const closeButton = isRightDrawerSort
          ? document.querySelector('.mobile-close-right')
          : document.querySelector('.mobile-close-left');
        closeButton?.click();
      }
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.dispatchActiveFacetsCount(document);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
  }

  initGeneralMenu() {
    document.addEventListener('DOMContentLoaded', function () {
      const entries = document.querySelectorAll('.filter-entry');
      const mainView = document.querySelectorAll('.filter-main-view');
      const subviews = document.querySelectorAll('.filter-subview');
      const parent = document.querySelector('.mobile-facets__inner-left');
      const allChildDivs = parent.children;
      const filterDrawer = document.querySelector('.filter-drawer');

      entries.forEach((entry) => {
        entry.addEventListener('click', () => {
          const index = entry.dataset.filterIndex;
          mainView.forEach((div) => {
            div.classList.add('not-visible');
            div.classList.remove('visible');
          });
          document
            .querySelector(`.filter-subview[data-filter-subview="${index}"]`)
            .classList.remove('not-visible');
          document
            .querySelector(`.filter-subview[data-filter-subview="${index}"]`)
            .classList.add('visible');
          Array.from(allChildDivs).forEach((div) => {
            div.classList.add('not-visible');
            div.classList.remove('visible');
          });
          filterDrawer.classList.remove('not-visible');
          filterDrawer.classList.remove('hols-mobile-menu');
          filterDrawer.classList.add('visible');
          parent.style.gap = '0px';
        });
      });

      document.querySelectorAll('.mobile-facets__close').forEach((button) => {
        button.addEventListener('click', () => {
          subviews.forEach((view) => view.classList.remove('visible'));
          subviews.forEach((view) => view.classList.add('not-visible'));
          mainView.forEach((div) => {
            div.classList.remove('not-visible');
            div.classList.add('visible');
          });
          Array.from(allChildDivs).forEach((div) => {
            div.classList.remove('not-visible');
            div.classList.add('visible');
          });
          filterDrawer.classList.remove('not-visible');
          filterDrawer.classList.add('hols-mobile-menu');

          setTimeout(() => {
            filterDrawer.classList.add('visible');
          }, 300);

          parent.style.gap = '14px';
        });
      });

      document.querySelectorAll('.back-button').forEach((button) => {
        button.addEventListener('click', () => {
          subviews.forEach((view) => view.classList.remove('visible'));
          subviews.forEach((view) => view.classList.add('not-visible'));
          mainView.forEach((div) => {
            div.classList.remove('not-visible');
            div.classList.add('visible');
          });
          Array.from(allChildDivs).forEach((div) => {
            div.classList.remove('not-visible');
            div.classList.add('visible');
          });
          filterDrawer.classList.remove('not-visible');
          filterDrawer.classList.add('hols-mobile-menu');

          setTimeout(() => {
            filterDrawer.classList.add('visible');
          }, 300);

          parent.style.gap = '14px';
        });
      });
    });
  }

  slider(element) {
    // Mobile-only per your original guard
    if (window.innerWidth > 600) return;

    // ---- helpers -------------------------------------------------------------
    const toNum = (x) => x == null ? NaN : (typeof x === 'number' ? x : parseFloat(String(x).replace(/[^0-9.\-]/g, '')));
    const clamp = (v, a, b) => Math.max(a, Math.min(v, b));
    const pct = (v, max) => (v / max) * 100;

    const readFromURL = (param) => {
      const sp = new URLSearchParams(location.search);
      const raw = sp.get(param);
      const cents = toNum(raw);
      return isNaN(cents) ? null : cents / 100; // cents → major units (UI)
    };

    const findPriceInputs = (el, nameMin, nameMax) => {
      const stable =
        el.closest('facet-filters-form') ||
        el.closest('[data-section-id]') ||
        el.closest('form') ||
        document;

      const scope =
        (el.previousElementSibling && el.previousElementSibling.tagName.toLowerCase() === 'price-range')
          ? el.previousElementSibling
          : stable.querySelector('price-range') || stable;

      return {
        scope,
        iMin: scope.querySelector(`input[name="${CSS.escape(nameMin)}"]`),
        iMax: scope.querySelector(`input[name="${CSS.escape(nameMax)}"]`),
        form: scope.closest('form') || el.closest('form') || document.querySelector('form')
      };
    };

    // Remove duplicate inputs with same name (except keepEl)
    const neutralizeCompeting = (form, name, keepEl) => {
      if (!form) return;
      form.querySelectorAll(`[name="${CSS.escape(name)}"]`).forEach(el => {
        if (el === keepEl) return;
        if (!el.dataset.dualNeutralized) {
          el.dataset.dualNeutralized = '1';
          el.dataset.dualPrevName = el.name;
          el.removeAttribute('name');
          el.disabled = true;
        }
      });
    };

    // ---- init per slider container ------------------------------------------
    element.querySelectorAll('.dual-range').forEach((el) => {
      if (el.__dualInit) return;
      el.__dualInit = true;

      const minAbs = toNum(el.dataset.min) || 0;
      const maxAbs = toNum(el.dataset.max) || 100;
      const nameMin = el.dataset.nameMin;
      const nameMax = el.dataset.nameMax;

      const rMin = el.querySelector('.dual-range__input--min');
      const rMax = el.querySelector('.dual-range__input--max');
      const fill = el.querySelector('.dual-range__fill');

      let { iMin, iMax, form } = findPriceInputs(el, nameMin, nameMax);

      // Decide initial slider positions (DO NOT seed the named inputs)
      const chooseInitial = () => {
        // 1) If inputs already have values (from URL or previous state), reflect them to sliders visually
        const hasMin = iMin && iMin.value !== '';
        const hasMax = iMax && iMax.value !== '';
        if (hasMin || hasMax) {
          let a = hasMin ? toNum(iMin.value) : minAbs;
          let b = hasMax ? toNum(iMax.value) : maxAbs;
          a = clamp(isNaN(a) ? minAbs : a, minAbs, maxAbs);
          b = clamp(isNaN(b) ? maxAbs : b, minAbs, maxAbs);
          if (a > b) b = a;
          return [a, b];
        }
        // 2) Liquid-rendered slider values
        let a = toNum(rMin.value), b = toNum(rMax.value);
        if (!isNaN(a) && !isNaN(b)) {
          a = clamp(a, minAbs, maxAbs);
          b = clamp(b, minAbs, maxAbs);
          if (a > b) b = a;
          return [a, b];
        }
        // 3) URL params (if inputs weren’t prefilled)
        let uA = readFromURL(nameMin);
        let uB = readFromURL(nameMax);
        if (uA != null || uB != null) {
          a = clamp(uA == null ? minAbs : uA, minAbs, maxAbs);
          b = clamp(uB == null ? maxAbs : uB, minAbs, maxAbs);
          if (a > b) b = a;
          return [a, b];
        }
        // 4) Defaults
        return [minAbs, maxAbs];
      };

      const renderFill = (a, b) => {
        if (!fill) return;
        fill.style.left  = pct(a, maxAbs) + '%';
        fill.style.right = (100 - pct(b, maxAbs)) + '%';
      };

      // Don’t touch named inputs until the user interacts
      let userInteracted = false;

      // Bootstrap: set slider visuals only
      {
        const [a0, b0] = chooseInitial();
        rMin.value = a0;
        rMax.value = b0;
        renderFill(a0, b0);
      }

      // Keep min <= max
      const clampRanges = (whichMoved) => {
        let a = toNum(rMin.value), b = toNum(rMax.value);
        a = clamp(a, minAbs, maxAbs);
        b = clamp(b, minAbs, maxAbs);
        if (a > b) {
          if (whichMoved === 'min') rMax.value = a;
          else rMin.value = b;
        }
      };

      // Slider → Inputs (only after user interaction)
      const setInputsFromSliders = (whichChanged) => {
        let a = toNum(rMin.value), b = toNum(rMax.value);
        if (a > b) whichChanged === rMin ? (b = a) : (a = b);
        a = clamp(a, minAbs, maxAbs);
        b = clamp(b, minAbs, maxAbs);

        rMin.value = a; rMax.value = b; renderFill(a, b);

        ({ iMin, iMax, form } = findPriceInputs(el, nameMin, nameMax));
        if (!iMin || !iMax || !userInteracted) return;

        // Edge logic: clear inputs at edges so those params aren't submitted
        iMin.value = (a > minAbs) ? String(a) : '';
        iMax.value = (b < maxAbs) ? String(b) : '';

        // De-dupe: ensure only these two inputs can submit these names
        neutralizeCompeting(form, nameMin, iMin);
        neutralizeCompeting(form, nameMax, iMax);
      };

      // Inputs → Slider (text fields edited by user)
      const setSlidersFromInputs = (changedEl) => {
        ({ iMin, iMax, form } = findPriceInputs(el, nameMin, nameMax));
        if (!iMin && !iMax) return;

        userInteracted = true; // treat as real interaction

        let a = iMin && iMin.value !== '' ? toNum(iMin.value) : toNum(rMin.value);
        let b = iMax && iMax.value !== '' ? toNum(iMax.value) : toNum(rMax.value);

        a = clamp(isNaN(a) ? toNum(rMin.value) : a, minAbs, maxAbs);
        b = clamp(isNaN(b) ? toNum(rMax.value) : b, minAbs, maxAbs);

        if (a > b) {
          if (changedEl === iMin) b = a;
          else if (changedEl === iMax) a = b;
        }

        rMin.value = a; rMax.value = b; renderFill(a, b);

        // Reflect back edge clearing so form won’t submit defaults
        if (iMin) iMin.value = (a > minAbs) ? String(a) : '';
        if (iMax) iMax.value = (b < maxAbs) ? String(b) : '';

        neutralizeCompeting(form, nameMin, iMin);
        neutralizeCompeting(form, nameMax, iMax);
      };

      // Bind slider events
      rMin.addEventListener('input', () => { userInteracted = true; clampRanges('min'); setInputsFromSliders(rMin); });
      rMax.addEventListener('input', () => { userInteracted = true; clampRanges('max'); setInputsFromSliders(rMax); });

      // Bind input events (if present)
      const bindInputs = () => {
        ({ iMin, iMax, form } = findPriceInputs(el, nameMin, nameMax));
        if (iMin && !iMin.__dualBound) {
          iMin.addEventListener('input', (e) => setSlidersFromInputs(e.target));
          iMin.addEventListener('change', (e) => setSlidersFromInputs(e.target));
          iMin.__dualBound = true;
        }
        if (iMax && !iMax.__dualBound) {
          iMax.addEventListener('input', (e) => setSlidersFromInputs(e.target));
          iMax.addEventListener('change', (e) => setSlidersFromInputs(e.target));
          iMax.__dualBound = true;
        }
      };
      bindInputs();

      // Watch for theme/editor re-renders of the inputs
      const observeTarget =
        el.closest('facet-filters-form') ||
        el.closest('[data-section-id]') ||
        el.closest('form') ||
        document;

      const mo = new MutationObserver(() => { bindInputs(); });
      mo.observe(observeTarget, { childList: true, subtree: true });

      // Final safety: de-dupe right before submit
      if (form && !form.__dualSubmitPatched) {
        form.addEventListener('submit', () => {
          ({ iMin, iMax } = findPriceInputs(el, nameMin, nameMax));
          neutralizeCompeting(form, nameMin, iMin);
          neutralizeCompeting(form, nameMax, iMax);
        }, { capture: true });
        form.__dualSubmitPatched = true;
      }
    });
  }


  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);